import { useEffect, useState } from "react";
import { format, addDays } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { api } from "@/lib/api";

export const SlotPicker = ({ date, setDate, slot, setSlot }) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!date) { setSlots([]); return undefined; }
    let alive = true;
    setLoading(true);
    api.get("/availability", { params: { date: format(date, "yyyy-MM-dd") } })
      .then((r) => { if (alive) setSlots(Array.isArray(r.data?.slots) ? r.data.slots : []); })
      .catch(() => { if (alive) setSlots([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [date]);

  return (
    <div className="grid gap-6 md:grid-cols-2">
      <div className="bg-white border border-ink/15 flex justify-center" data-testid="booking-calendar">
        <Calendar mode="single" selected={date} onSelect={(d) => { setDate(d); setSlot(""); }}
          disabled={[{ before: addDays(new Date(), 1) }, { dayOfWeek: [0] }, { after: addDays(new Date(), 90) }]}
          classNames={{ day_selected: "bg-ink text-white hover:bg-ink hover:text-white focus:bg-ink focus:text-white", day_today: "border border-brass" }}
          className="p-4" />
      </div>
      <div>
        <p className="text-sm font-semibold mb-3">{date ? format(date, "EEEE d MMMM") : "Choose a date first"}</p>
        <div className="grid gap-2" data-testid="time-slots">
          {loading && <p className="text-sm text-slate-500">Checking availability…</p>}
          {!loading && slots.map((s, i) => (
            <button type="button" key={s.label} disabled={!s.available} onClick={() => setSlot(s.label)} data-testid={`time-slot-${i}`}
              className={`h-12 px-4 flex items-center justify-between border text-sm font-semibold transition-colors ${slot === s.label ? "bg-ink text-white border-ink" : s.available ? "bg-white border-ink/15 hover:border-ink" : "bg-bone/60 text-slate-400 border-transparent line-through cursor-not-allowed"}`}>
              {s.label}<span className="font-mono text-[11px] uppercase">{s.available ? (slot === s.label ? "Selected" : "Available") : "Booked"}</span>
            </button>
          ))}
        </div>
        <p className="mt-4 text-xs text-slate-500">Arrival windows are requests — we'll call or email to confirm. Blocked drain or emergency? Call our 24/7 line on 0452 538 075.</p>
      </div>
    </div>
  );
};
